import React from 'react';
import { Helmet } from 'react-helmet';
import { SITECODE } from '@match/app-rules-resolver';
import { useTheme } from 'packages/theming';
import { useSiteData, useWebchatWidgetKey } from 'modules/hooks';

const Head = () => {
  const theme = useTheme();
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const favicon = require(`./${theme.branding.favIconName}.ico`);

  const { widgetKey } = useWebchatWidgetKey();
  const siteData = useSiteData();
  const isLatam = siteData.siteCode === SITECODE.LAT_AM;
  const widgetSrc = `https://static.zdassets.com/ekr/snippet.js?key=${widgetKey}`;

  return (
    <Helmet>
      {isLatam && widgetKey && <script id="ze-snippet" src={widgetSrc} />}
      <title>{theme.branding.siteName}</title>
      <link rel="icon" href={favicon}></link>
    </Helmet>
  );
};

export default Head;
